<template>
  <div class="notFoundPage">
    <div class="notFoundPageIco">
      <img src="/img/page-notfound.svg" alt="">
    </div>
    <div class="notFoundPageText" v-if="btnText">{{title}}</div>
    <div class="notFoundPageBtn" v-if="btnRoute && btnText">
      <router-link :to="btnRoute" class="btn btn-primary">
        <i v-if="btnIco" :class="btnIco"></i>
        {{btnText}}
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: () => ""
      },
      btnText: {
        type: String,
        default: () => ""
      },
      btnRoute: {
        type: Object,
        default: () => null
      },
      btnIco: {
        type: String,
        default: () => ""
      }
    },
    computed: {},
    created() {},
    methods: {}
  };
</script>